import EventsService from "../service/EventsService";
import {
  FETCH_BIRTHDAY_REQUEST,
  FETCH_BIRTHDAY_SUCCESS,
  FETCH_BIRTHDAY_FAILURE,
} from "../constants/EventsConstants";

export const fetchEmployeeBirthdayList = () => async (dispatch) => {
  dispatch({ type: FETCH_BIRTHDAY_REQUEST });

  try {
    const response = await EventsService.GetEmployeeBirthdayList();

    dispatch({
      type: FETCH_BIRTHDAY_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    console.error("Error fetching employee birthday list:", error);
    dispatch({ type: FETCH_BIRTHDAY_FAILURE });
  }
};
